import { Route } from "react-router-dom";
import { RequireUserPermissions } from "src/components/Permissions/RequireUserPermissions";
import { FormTemplate } from "src/scenes/orgAdmin/formTemplates";
import { FormTemplates } from "src/services/url/OrgAdmin";

export const FormTemplateRoutes = (
  <>
    <Route
      path={FormTemplates.editPath}
      element={
        <RequireUserPermissions
          permission={["form_template:read", "form_template:update"]}
        >
          <FormTemplate mode="edit" />
        </RequireUserPermissions>
      }
    />
    <Route
      path={FormTemplates.viewPath}
      element={
        <RequireUserPermissions permission="form_template:read">
          <FormTemplate mode="view" />
        </RequireUserPermissions>
      }
    />
  </>
);
